import {
  FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP,
  NEW_SOLICITOR_UPDATE_LAWSYS_FIELD,
  RECEIVE_LAWSYS_FIRM_GROUP,
  RECEIVE_LAWSYS_FIRMS, RECEIVE_LAWSYS_FIRMS_WITH_AGENTS,
  RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN,
  REQUEST_LAWSYS_FIRMS,
  REQUEST_LAWSYS_FIRMS_FILTERED,
  RECEIVE_LAWSYS_FIRMS_FILTERED,
  REQUEST_LAWSYS_FIRMS_WITH_AGENTS,
  CHANGE_LAWSYS_FIRM_STATE,
  RECEIVE_POST_NEW_SOLICITOR_RESPONSE,
  RECEIVE_GET_SELECTED_SOLICITOR_USER,
  RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP,
  REQUEST_LAWSYS_FIRM_GROUP,
} from "../actions/index";
import {LOGOUT, RECEIVE_SOLICITOR_EDIT} from "../actions";
import _ from "lodash";
import {LOCATION_CHANGE} from "connected-react-router";

const defaultState = {
    lawsysFirms: [],
    lawsysFirmsFiltered: [],
    fetching: false,
    badFetchResponse: '',
    fetchingLawsysFirmGroup: false,
    suggestionFieldValue: '',
    selectedLawsysFirmsDropdown: [],
    selectedLawsysFirms: [],
    solicitorGroup:'',
    fetchingLawsysFirmGroup: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_LAWSYS_FIRM_GROUP:
            return {
                ...state,
                fetchingLawsysFirmGroup: true,
            };
        case RECEIVE_SOLICITOR_EDIT:
            return {
                ...state,
                fetching: false,
                lawsysFirms: action.payload.solicitors
            };
        case NEW_SOLICITOR_UPDATE_LAWSYS_FIELD:
            return {
                ...state,
                fetchingLawsysFirmGroup: true
            };
        case RECEIVE_LAWSYS_FIRM_GROUP:
            var solicitorGroupResponse;
            try {
                solicitorGroupResponse= action.payload.body == null?'':action.payload.body;
            } catch (error) {
                solicitorGroupResponse= 'Failed to get solicitor group info'
            }
            return {
                ...state,
                solicitorGroup:solicitorGroupResponse,
                fetchingLawsysFirmGroup: false
            };
        case FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP:
            return {
                ...state,
                fetchingLawsysFirmGroup: false
            };
        case RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN:
            return {
                ...state,
                lawsysFirms: action.payload.solicitors
            };
        case REQUEST_LAWSYS_FIRMS:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_LAWSYS_FIRMS:
            return {
                ...state,
                fetching: false,
                lawsysFirms: action.payload
            };
        case REQUEST_LAWSYS_FIRMS_FILTERED:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_LAWSYS_FIRMS_FILTERED:
            return {
                ...state,
                fetching: false,
                lawsysFirmsFiltered: action.payload,
                lawsysFirms: _.cloneDeep(action.payload)
            };
        case REQUEST_LAWSYS_FIRMS_WITH_AGENTS:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_LAWSYS_FIRMS_WITH_AGENTS:
            return {
                ...state,
                fetching: false,
                lawsysFirms: action.payload
            };
        case CHANGE_LAWSYS_FIRM_STATE: {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        };
        case RECEIVE_POST_NEW_SOLICITOR_RESPONSE:{
            return {
                ...state,
                lawsysFirmsFiltered: [],
                suggestionFieldValue: '',
                selectedLawsysFirmsDropdown: [],
                selectedLawsysFirms: []
            };           
        };
        case RECEIVE_GET_SELECTED_SOLICITOR_USER: {
            if (!action.payload) return state;
            const lawsysFirm = {id: action.payload.lawsysId ? action.payload.lawsysId : '', name: action.payload.lawsysName ? action.payload.lawsysName : '', aragProvider: action.payload.aragProvider};
            return {
                ...state,
                lawsysFirmsFiltered: [lawsysFirm],
                suggestionFieldValue: '',
                selectedLawsysFirmsDropdown: [lawsysFirm],
                selectedLawsysFirms: [lawsysFirm]
            };
        }
        case RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP: {
            if (!action.payload) 
                return state;
            if (state.selectedLawsysFirmsDropdown.length === 0 )
            {
                const lawsysfirms = action.payload.solicitors.map(s => ({id: s.lawsysFirmId, name: s.lawsysFirm, aragProvider: s.aragProvider }));
                return {
                    ...state,
                    selectedLawsysFirmsDropdown: lawsysfirms,
                };
            }
            return state;
        }
        case LOCATION_CHANGE:
            return  defaultState;
        case LOGOUT:
            return  defaultState;
        default:
            return state
    }
}